import z from "zod";

import { QuiltedHealthValueSets } from "@/fhir/enums/quilted-health";

export interface BloodTypeDrawerProps {
  opened: boolean;
  onClose: () => void;
  clientId: string;
  encounterId?: string;
  onSuccess?: (bloodType: string | null) => Promise<void>;
}

export const bloodTypeFormSchema = z.object({
  bloodType: z.string().optional(),
});

export type BloodTypeFormValues = z.infer<typeof bloodTypeFormSchema>;

export const BLOOD_TYPE_VALUE_SET_URL = QuiltedHealthValueSets.BloodType;
